import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from "./actions";
import {
    getDriverStatsApi,
    getExceedingRpmLimitByDriverApi,
    getExceedingRpmLimitByVehicleApi, getExceedingSpeedLimitByDriverApi,
    getExceedingSpeedLimitByVehicleApi, getIgnitionOnRpmByVehicleIdApi, getIgnitionOnSpeedByVehicleIdApi
} from "../../services/customer_exceeding_limits.service";
import { AxiosResponse } from 'axios';
import logError from "../../utils/logError";

export function* GET_EXCEEDING_SPEED_VEHICLE(action: {payload: any, type: string}){
    try{
        const response: AxiosResponse<any> = yield call(getExceedingSpeedLimitByVehicleApi, action.payload);
        if(response.data){
            yield put({
                type: actions.SET_EXCEEDING_SPEED_BY_VEHICLE_ID,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/customer_exceeding_limits/sagas/GET_EXCEEDING_SPEED_VEHICLE", e); }
}

export function* GET_EXCEEDING_RPM_VEHICLE(action: {payload: any, type: string}){
    try{
        const response: AxiosResponse<any> = yield call(
          getExceedingRpmLimitByVehicleApi,
          action.payload
        );
        if(response.data){
            yield put({
                type: actions.SET_EXCEEDING_RPM_BY_VEHICLE_ID,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/customer_exceeding_limits/sagas/GET_EXCEEDING_RPM_VEHICLE", e); }
}

export function* GET_EXCEEDING_RPM_DRIVER(action: {payload: any, type: string}){
    try{
        const response: AxiosResponse<any> = yield call(
          getExceedingRpmLimitByDriverApi,
          action.payload
        );
        if(response.data){
            yield put({
                type: actions.SET_EXCEEDING_RPM_BY_DRIVER_ID,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/customer_exceeding_limits/sagas/GET_EXCEEDING_RPM_DRIVER", e); }
}

export function* GET_EXCEEDING_SPEED_DRIVER(action: {payload: any, type: string}){
    try{
        const response: AxiosResponse<any> = yield call(
          getExceedingSpeedLimitByDriverApi,
          action.payload
        );
        if(response.data){
            yield put({
                type: actions.SET_EXCEEDING_SPEED_BY_DRIVER_ID,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/customer_exceeding_limits/sagas/GET_EXCEEDING_SPEED_DRIVER", e); }
}

export function* GET_DRIVER_STATS(action: {payload: any, type:string}){
    try{
        const response: AxiosResponse<any> = yield call(
          getDriverStatsApi,
          action.payload
        );
        if(response.data){
            yield put({
                type: actions.SET_DRIVER_STATS,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/customer_exceeding_limits/sagas/GET_DRIVER_STATS", e); }
}

export function* GET_IGNITION_ON_SPEED_BY_VEHICLE_ID(action: {payload: any, type:string}){
    try{
        const response: AxiosResponse<any> = yield call(
          getIgnitionOnSpeedByVehicleIdApi,
          action.payload
        );
        if(response.data){
            yield put({
                type: actions.SET_IGNITION_ON_SPEED_BY_VEHICLE_ID,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/customer_exceeding_limits/sagas/GET_IGNITION_ON_SPEED_BY_VEHICLE_ID", e); }
}

export function* GET_IGNITION_ON_RPM_BY_VEHICLE_ID(action: {payload: any, type:string}){
    try{
        const response: AxiosResponse<any> = yield call(
          getIgnitionOnRpmByVehicleIdApi,
          action.payload
        );
        if(response.data){
            yield put({
                type: actions.SET_IGNITION_ON_RPM_BY_VEHICLE_ID,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/customer_exceeding_limits/sagas/GET_IGNITION_ON_RPM_BY_VEHICLE_ID", e); }
}


export default function* RootSaga(){
    yield all([
        takeEvery(actions.GET_EXCEEDING_SPEED_BY_VEHICLE_ID, GET_EXCEEDING_SPEED_VEHICLE),
        takeEvery(actions.GET_EXCEEDING_RPM_BY_VEHICLE_ID, GET_EXCEEDING_RPM_VEHICLE),
        takeEvery(actions.GET_EXCEEDING_RPM_BY_DRIVER_ID, GET_EXCEEDING_RPM_DRIVER),
        takeEvery(actions.GET_EXCEEDING_SPEED_BY_DRIVER_ID, GET_EXCEEDING_SPEED_DRIVER),
        takeEvery(actions.GET_DRIVER_STATS, GET_DRIVER_STATS),
        takeEvery(actions.GET_IGNITION_ON_RPM_BY_VEHICLE_ID, GET_IGNITION_ON_RPM_BY_VEHICLE_ID),
        takeEvery(actions.GET_IGNITION_ON_SPEED_BY_VEHICLE_ID, GET_IGNITION_ON_SPEED_BY_VEHICLE_ID),
    ])
}